import type { RouteObject } from "react-router-dom";
import { InvitePage } from "./pages/InvitePage";

export const inviteRoutes: RouteObject[] = [
  {
    path: "invite/:token",
    element: <InvitePage />,
  },
];
